import React from 'react';
import { Card, Skeleton } from 'antd';
import './NewGroupCard.less';

const TNewGroupCardSkeleton: React.FC = () => {
  return (
    <Card
      className="t-skeleton-group-container"
      cover={<Skeleton.Image className="t-skeleton-cover-image" />}
    >
      <Skeleton round active paragraph={{ rows: 2 }} />
    </Card>
  );
};

export default TNewGroupCardSkeleton;
